import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";

// 회사 이름 (OCI + WRAPSODY 에서만 노출)
const CompanyName = () => {
  const { isOciProduct } = useProductFlags();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  return (
    <div className="form-item">
      {isOciProduct &&
        window.sessionStorage.getItem("product") === "WRAPSODY" && (
          <Form.Group className="mb-3">
            <Form.Label>{t("logIn.signUp.companyName")}</Form.Label>
            <Form.Control
              type="text"
              {...register("companyName")}
              maxLength={256}
              placeholder={t("logIn.signUp.companyName")}
              className={"custom-form"}
              isInvalid={!!errors.companyName}
            />
            <Form.Control.Feedback type="invalid">
              <>{errors?.companyName?.message}</>
            </Form.Control.Feedback>
          </Form.Group>
        )}
    </div>
  );
};

export default CompanyName;
